import React from "react";
import { Link } from "react-router-dom";
import { Heroaboutus, Hero2, Visimisi, Person1 } from "../assets/images";
import { LogoInverted } from "../assets/icons";
import Slider from "react-slick"
import { Logo1, Logo2, Logo3, Logo4, Logo5, Logo6, Logo7, Logo8, Logo9, Logo10, Logo11, Logo12, Logo13, Logo14, Logo15, Logo16, Logo17, Logo18, Logo19, Logo20, Logo21, Logo22, Logo23, Logo24, Logo25 } from '../assets/logo';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { GoLaw } from "react-icons/go"
import { IoSchoolOutline } from "react-icons/io5"

function Aboutus() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 0,
    cssEase: "linear"
  };
  return (
    <div className="pt-12">

      {/* Header Desktop */}
      <div
        style={{
          backgroundImage: `url(${Heroaboutus})`,
          backgroundPosition: "center",
          backgroundAttachment: "scroll",
          backgroundSize: "cover",
        }}
        className="md:w-full md:flex-row flex-col w-full mx-auto md:flex justify-center items-center py-36 hidden"
      >
        <div className="flex-1 md:order-1 order-2 flex justify-center">
          <div data-aos="fade-up" className="w-7/12 flex flex-col items-center">
            <img src={LogoInverted} alt="Logo Temps" className="object-cover md:w-9/12 w-8/12" />
            <h2 className="text-xl font-normal mt-3 text-white tracking-wide text-center">
              Legal Strategies For Business Success
            </h2>
          </div>
        </div>
      </div>

      {/* Header Small */}
      <div style={{ backgroundImage: `url(${Heroaboutus})`, backgroundPosition: 'center', backgroundAttachment: 'fixed', backgroundSize: '180%' }} className="md:hidden mt-2 block">
        <div className="container pt-36 pb-36 s:w-screen w-4/5 mx-auto flex justify-center"  >
          <div data-aos="fade-left" className="flex-1 flex flex-col justify-center items-center">
            <img src={LogoInverted} alt="Logo Temps" className="object-cover md:w-full w-8/12" />
            <h2 style={{ textShadow: '1.5px 1.5px 0 rgba(10,10,10,.5)' }} className="text-xl text-center mt-8 text-white tracking-wide ">
              Legal Strategies For Business Success
            </h2>
          </div>
        </div>
      </div>

      <h1 data-aos="fade-up" className="font-semibold underline underline-offset-8 text-2xl mt-8 text-primary text-center md:ml-32 md:mr-32 ml-5 mr-5">
        Sejak Tahun <span className="text-secondary underline underline-offset-8 "> 2008 Hingga Kini</span>
      </h1>
      <h1 data-aos="fade-up" className="text-xl mt-8 text-primary text-center md:ml-32 md:mr-32 ml-5 mr-5">
        Selama lebih dari satu dekade, TEMPS menjadi bagian tak terpisahkan dari perjalanan
        pangan dan ekonomi di Indonesia bagian barat. Pada tahun 2008, perjalanan dimulai
        sebagai usaha perorangan di sektor pertanian dan perkebunan. Tidak hanya menjadi
        suatu badan usaha, TEMPS sukses berkembang dan berdampak positif bagi bisnis multisektor
        di Indonesia. Pencapaian dalam berbagai sektor dari perdagangan hingga konsultan hukum menjadi
        wujud komitmen dalam menopang pertumbuhan ekonomi Indonesia saat ini dan di masa yang akan datang
      </h1>

      {/* Visi Misi */}
      <div className="md:w-10/12 w-11/12 md:flex-row flex-col mt-32 mx-auto flex justify-center items-center">
        <div data-aos="flip-left" className="flex-1 md:order-1 flex justify-center">
          <img src={Visimisi} alt="Tentang Kami" className="object-cover md:w-9/12 w-8/12" />
        </div>
        <div data-aos="fade-right" className="flex-1 md:order-2 md:mt-0 mt-11">
          <h2 className="text-4xl font-bold text-primary tracking-wide ">
            Visi
          </h2>
          <p className="text-lg text-primary tracking-wide mt-3">
            Menjalin hubungan baik yang bertanggung jawab</p>
          <h2 className="text-4xl font-bold text-primary tracking-wide mt-8 ">
            Misi
          </h2>
          <p className="text-lg text-primary tracking-wide mt-3">
            Berkolaborasi dan tumbuh bersama</p>
        </div>
      </div>

      {/* Visi Misi */}
      <div className="md:w-10/12 w-11/12 md:flex-row flex-col mt-32 mx-auto flex justify-center items-center pb-3">
        <div data-aos="flip-left" className="flex-1 md:order-2 flex justify-center">
          <div data-aos="flip-left" className="flex flex-col overflow-hidden rounded-lg cursor-pointer h-90  w-80 lg:w-80 md:w-80 m-3">
            <img alt="profil" src={Person1} className="relative z-10 mx-auto object-cover rounded-lg h-40 w-40  border-2 border-secondary -mb-20" />
            <div className="py-4 pt-24 bg-primary rounded-lg shadow-lg z-0 border-primary border-2">
              <div className="text-center">
                <p className="text-lg text-secondary font-semibold ">
                  Dr. Sahat Tambunan, SH, MH, CLA.,
                </p>
                <p className="text-lg font-light text-white ">
                  Head Consultant Temps Int. Law Firm
                </p>
              </div>
            </div>
          </div>
        </div>
        <div data-aos="fade-right" className="flex-1 md:order-1 md:mt-0 mt-11">
          <h2 className="text-4xl font-bold text-primary tracking-wide ">
            Our Head <span className="border-b-secondary border-b-4 font-extrabold"> Consultant </span>
          </h2>
          <p className="text-lg text-primary tracking-wide mt-3 text-justify">
            Dr. Sahat Tambunan, SH, MH, CLA., adalah konsultan hak kekayaan intelektual yang diakui oleh DJKI, menyediakan layanan konsultasi terdepan untuk perlindungan aset intelektual, dan menjadi pionir dalam membantu klien mencapai tujuan hukum.
          </p>
          <div className="flex items-center mt-3">
            <IoSchoolOutline className="text-white bg-primary rounded-full p-2 text-5xl" />
            <p className="text-lg text-primary tracking-wide ml-3">
              Bachelor of Science in Law University of Indonesia
            </p>
          </div>
          <div className="flex items-center mt-3">
            <IoSchoolOutline className="text-white bg-primary rounded-full p-2 text-5xl" />
            <p className="text-lg text-primary tracking-wide ml-3">
              Magister of Law University of Jayabaya
            </p>
          </div>
          <div className="flex items-center mt-3">
            <GoLaw className="text-white bg-primary rounded-full p-2 text-5xl" />
            <p className="text-lg text-primary tracking-wide ml-3">
              IP Consultant by DJKI No. 1097 - 2020
            </p>
          </div>
        </div>

      </div>

      {/* Portofolio */}
      <div className="mainContainer overflow-x-hidden md:px-24 px-10">
        <h2 data-aos="fade-down" className='text-4xl font-bold text-center text-primary my-16'>
          Our Clients
        </h2>
        <Slider {...settings} data-aos="fade-up" className='flex items-center justify-center mb-16'>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo1} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo2} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo3} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo4} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo5} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo6} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo7} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo8} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo9} className='w-full h-16 object-contain' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo10} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo11} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo12} className='w-ful h-16 object-containl' />
          </div>
        </Slider>
        <Slider {...settings} data-aos="fade-up" className='flex items-center justify-center mb-16'>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo13} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo14} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo15} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo16} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo17} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo18} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo19} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo20} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo21} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo22} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo23} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo24} className='w-ful h-16 object-containl' />
          </div>
          <div className="container flex items-center w-16 justify-center">
            <img src={Logo25} className='w-ful h-16 object-containl' />
          </div>
        </Slider>
      </div>



    </div>
  );
}

export default Aboutus;
